import { useState } from "react";

import { DataContext } from "../../../Context/HelperOne";
import NavBar from "../nav_bar/Navbar";
import PaymentList from "./PaymentList";

const Payment = () => {
         const [searchUi, setSearchUi] = useState(true)
        const [searchData, setSearchData] = useState(null)
  return (
    <div>
          <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
                  <NavBar
                      childrenPage={<PaymentList />}
                      menuId={11}
                  />
              </DataContext.Provider>
    </div>
  )
}

export default Payment
